// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2W2bN","notes":"Notes_notes__uxolL"};